export const ObjectUtils = {

  /**
   * Convert an object that looks like an Array to an actual Array because Javascript.
   *
   * @param object
   * @return {Array}
   */
  toArray (object) {
    const array = [];
    for (let prop in object) {
      if (object.hasOwnProperty(prop)) {
        array.push(object[prop]);
      }
    }

    return array;
  }
};
